import { useEffect } from 'react';

import { loadAccess, useAccess } from '../../services/access';

// Loads the user's access for the project before the app shell mounts, so
// the shell never sends a call the user is not allowed to make.
const AccessGate = ({ token, children }) => {
  const { status } = useAccess();

  useEffect(() => {
    loadAccess(token);
  }, [token]);

  if (status === 'unknown' || status === 'loading') return null;
  return children;
};

export default AccessGate;
